// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13u61","name":"styles_name__2GakV","phone":"styles_phone__2_dcY"};